import { useEffect, useState } from 'react';

const KakaoMap = ({ address, viewAddress }) => {
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      '//dapi.kakao.com/v2/maps/sdk.js?appkey=f13019242b609368c584a4bce2ed9289&libraries=services&autoload=false';
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.kakao.maps.load(() => {
        setMapLoaded(true);
      });
    };
  }, []);

  useEffect(() => {
    if (!mapLoaded) return;

    const geocoder = new window.kakao.maps.services.Geocoder();

    geocoder.addressSearch(address, (result, status) => {
      if (status === window.kakao.maps.services.Status.OK) {
        const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);

        const container = document.getElementById('map');
        const options = {
          center: coords,
          level: 2,
        };
        const map = new window.kakao.maps.Map(container, options);

        const marker = new window.kakao.maps.Marker({
          map,
          position: coords,
        });

        const infowindow = new window.kakao.maps.InfoWindow({
          disableAutoPan: true,
          content: `<div style="width:150px;text-align:center; padding:5px;font-size:14px;font-weight: 600; white-space: nowrap;">${viewAddress}</div>`,
        });
        infowindow.open(map, marker);
      } else {
        alert('주소를 찾을 수 없습니다.');
      }
    });
  }, [mapLoaded, address]);

  return <div id="map" style={{ width: '100%', height: '400px' }} />;
};

export default KakaoMap;
